export enum DocumentScannerConstants {
  SET_SCANNED_DOCUMENTS = 'documentScanner/SET_SCANNED_DOCUMENTS',

  IMPORT_DOCUMENTS = 'documentScanner/IMPORT_DOCUMENTS',
  GET_DOCUMENT_ATTACHMENTS = 'documentScanner/GET_DOCUMENT_ATTACHMENTS',
  SET_DOCUMENT_ATTACHMENTS = 'documentScanner/SET_DOCUMENT_ATTACHMENTS',
  SET_DISABLE_SCAN_BUTTON = 'documentScanner/SET_DISABLE_SCAN_BUTTON',

  DELETE_DOCUMENT_ATTACHMENT = 'documentScanner/DELETE_DOCUMENT_ATTACHMENT',

  RESET_DOCUMENT_SCANNER_STATE = 'documentScanner/RESET_DOCUMENT_SCANNER_STATE',
}
